import { render, staticRenderFns } from "./ReferencesPicker.vue?vue&type=template&id=56db3d40&scoped=true&"
import script from "./ReferencesPicker.vue?vue&type=script&lang=js&"
export * from "./ReferencesPicker.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesPicker.vue?vue&type=style&index=0&id=56db3d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db3d40",
  null
  
)

export default component.exports